import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { HospitalDirectoryListItem } from "@/features/hospital-directory/lib/directoryList";
import HospitalResultCardContent from "@/shared/ui/molecules/HospitalResultCardContent";
import { RankNumber } from "@/widgets/search-ranking/ui/atoms";
import { buildHospitalShortPath } from "@/entities/hospital/lib/detail-route";
type HospitalDirectoryCardProps = {
  locale: string;
  item: HospitalDirectoryListItem;
  categoryLabel?: string;
};

/**
 * 숫자는 이 목록에서의 순번이지 리뷰 랭킹 순위가 아니다.
 * 그래서 (1) 라벨이 "목록 순번"이고 (2) 상위 3위 보라 강조를 끄고 (3) 등락 배지를 렌더하지 않는다.
 * 목록 정렬은 평점순도 리뷰수순도 아니어서(실측: 1~5번 평점 4.5·4.4·4.6·4.5·4.2,
 * 리뷰 812·65·1,029·2,193·3,922로 둘 다 비단조) 순위처럼 보이는 표현은 전부 거짓이 된다.
 * 순위·등락 UI는 목록 자체가 랭킹인 /search/ranking의 몫이다.
 */
const HospitalDirectoryCard = t0 => {
  const $ = _c(16);
  const {
    locale,
    item,
    categoryLabel
  } = t0;
  let t1;
  if ($[0] !== item.hospitalOriginId || $[1] !== locale) {
    t1 = buildHospitalShortPath(locale, item.hospitalOriginId);
    $[0] = item.hospitalOriginId;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="sr-only">목록 순번</span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== item.position) {
    t3 = <div className="flex min-w-7 shrink-0 flex-col items-center justify-center">{t2}<RankNumber rank={item.position} highlightTopRanks={false} /></div>;
    $[4] = item.position;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== categoryLabel || $[7] !== item.address || $[8] !== item.name || $[9] !== item.reviewCount || $[10] !== item.score) {
    t4 = <div className="flex min-w-0 flex-1 flex-col justify-center"><HospitalResultCardContent name={item.name} address={item.address} categoryLabel={categoryLabel} score={item.score} reviewCount={item.reviewCount} /></div>;
    $[6] = categoryLabel;
    $[7] = item.address;
    $[8] = item.name;
    $[9] = item.reviewCount;
    $[10] = item.score;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t4) {
    t5 = <Link href={t1} className="flex w-full min-w-0 items-stretch gap-3 rounded-xl border border-gray-100 bg-white px-3.5 py-3.5 shadow-[0_1px_2px_rgba(38,38,44,0.04)]">{t3}{t4}</Link>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default HospitalDirectoryCard;